import React, { useEffect, useState } from "react";
import { CircularProgress, Container, Typography } from "@mui/material";
import { Grid } from "@mui/joy";
import FrameworkCard from "../../../components/FrameworkCard/FrameworkCard";
import ConfirmDialog from "../../../components/ConfirmDialog/ConfirmDialog";
import { useQuery } from "@apollo/client";
import { GET_FRAMEWORK_LIST } from "../../../apis/settingsApis/framework-apis/frameworkApis";

// Helper function to load logos dynamically
const getLogoImage = (logoName) => {
  try {
    return require(`../../../Assets/Images/${logoName}`).default;
  } catch (error) {
    console.error(`Logo ${logoName} not found`);
    return null;
  }
};

const Frameworks = ({ setBreadcrumbLists, openSecurityDetails }) => {
  const { loading, error, data, refetch } = useQuery(GET_FRAMEWORK_LIST);
  const [enabled, setEnabled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [frameworkName, setFrameworkName] = useState("");
  const [frameworksData, setFrameWorksData] = useState([]);

  useEffect(() => {
    setBreadcrumbLists(["Settings", "Frameworks"]);
  }, []);

  useEffect(() => {
    if (!data) return;

    // Map through data to dynamically add logo paths
    const frameworksWithLogos = data.getFramework.map((section) => ({
      ...section,
      frameworks: section.frameworks.map((framework) => ({
        ...framework,
        logo: getLogoImage(framework.framework_logo), // dynamically set logo path
      })),
    }));

    setFrameWorksData(frameworksWithLogos);
  }, [data]);

  const handleToggle = (index, title) => {
    if (index < 3) {
      setIsOpen(true);
      setFrameworkName(title);
    }
  };
  if (loading) {
    return (
      <Container
        component="main"
        maxWidth="xs"
        sx={{ textAlign: "center", mt: 8 }}
      >
        <CircularProgress />
      </Container>
    );
  }

  if (loading) {
    return (
      <Container
        component="main"
        maxWidth="xs"
        sx={{ textAlign: "center", mt: 8 }}
      >
        <CircularProgress />
      </Container>
    );
  }

  return (
    <>
      {frameworksData &&
        frameworksData.map((section, sectionIndex) => (
          <div key={sectionIndex}>
            <Typography variant="h5" gutterBottom mt={4} textAlign={"left"}>
              <b>{section.heading}</b> - {section.frameworks.length} Frameworks
            </Typography>
            <Grid container spacing={2}>
              {section.frameworks.map((framework, index) => (
                <Grid item xs={12} sm={4} key={index}>
                  <FrameworkCard
                    framework={framework}
                    title={framework.frameworkName}
                    areas={framework.area_count}
                    criteria={framework.criteria_count}
                    status={framework.status}
                    getInTouch={!framework.is_active}
                    enabled={framework.is_active}
                    logo={framework.framework_logo}
                    onToggle={() =>
                      handleToggle(index, framework.frameworkName)
                    }
                    index={index}
                    openDetails={() =>
                      openSecurityDetails(
                        framework,
                        "Frameworks",
                        framework?.framework_Id
                      )
                    }
                  />
                </Grid>
              ))}
            </Grid>
          </div>
        ))}

      <ConfirmDialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onConfirm={() => {
          setEnabled(!enabled);
          setIsOpen(false);
        }}
        heading={
          enabled ? `Disable ${frameworkName}` : `Enable ${frameworkName}`
        }
        content={
          enabled
            ? `Disabling ${frameworkName} will turn off SOC 2 Availability and SOC2 Confidentiality, as it is the base requirement within SOC2 standards. Are you sure you want to proceed?`
            : `Enabling ${frameworkName} will also activate SOC2 Availability and SOC2 Confidentiality. Are you sure you want to proceed?`
        }
        buttonText={enabled ? "Yes, Disable" : "Yes, Enable"}
      />
    </>
  );
};

export default Frameworks;
